<template>
  <el-dialog width="50%" :title="titleSetting" :visible="dialogVisible" :before-close="cancelConfirm" :close-on-click-modal="false" append-to-body top="8vh">
    <eco-input type="textarea" v-model="desc" placeholder="请复制数据" :maxlength="100000" :cols="50" :rows="30" />
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelConfirm()">取 消</el-button>
      <el-button type="primary" @click="submitImport">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  emits: ['emitsDesc'],
  data() {
    return {
      dialogVisible: false,
      titleSetting: '粘贴剪切板数据',
      desc: ''
    }
  },
  methods: {
    showDialog() {
      this.desc = ''
      this.dialogVisible = true
    },
    cancelConfirm() {
      this.desc = ''
      this.dialogVisible = false
    },
    submitImport() {
      this.$emit('emitsDesc', this.desc ? JSON.parse(this.desc) : [])
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped></style>
